import * as R from 'ramda';
import React from 'react';
import Loadable from 'react-loadable';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import getPageType from 'state/selectors/getPageType';
import ComponentMap from 'components/general/ComponentMap/ComponentMap';
import AccountLayoutSkeleton from 'components/layouts/AccountLayoutSkeleton';

const loading = () => (
  <AccountLayoutSkeleton />
);

// This is the level at which we route-split the content on screens.account.account
const sections = {
  ORGANISATION: Loadable({
    loading,
    loader: () => import('../../organisation/index'),
  }),
  ORGANISATION_INVITATIONS: Loadable({
    loading,
    loader: () => import('../../organisation/screens/invitations/index'),
  }),
  ORGANISATION_INVITATIONS_CREATE: Loadable({
    loading,
    loader: () => import('../../organisation/screens/invitations/screens/create/index'),
  }),
  ORGANISATION_USERS: Loadable({
    loading,
    loader: () => import('../../organisation/screens/users/index'),
  }),
  ORGANISATION_USERS_SINGLE: Loadable({
    loading,
    loader: () => import('../../organisation/screens/users/screens/single/index'),
  }),
  ORGANISATION_CUSTOMERS: Loadable({
    loading,
    loader: () => import('../../organisation/screens/customers/index'),
  }),
  ORGANISATION_CUSTOMERS_CREATE: Loadable({
    loading,
    loader: () => import('../../organisation/screens/customers/screens/create/index'),
  }),
  ORGANISATION_CUSTOMERS_SINGLE: Loadable({
    loading,
    loader: () => import('../../organisation/screens/customers/screens/customer/index'),
  }),
  ORGANISATION_CUSTOMERS_SINGLE_USERS: Loadable({
    loading,
    loader: () => import('../../organisation/screens/customers/screens/customer/screens/users/index'),
  }),
  ORGANISATION_CUSTOMERS_SINGLE_USERS_SINGLE: Loadable({
    loading,
    loader: () => import('../../organisation/screens/customers/screens/customer/screens/users/screens/single/index'),
  }),
  ORGANISATION_CUSTOMERS_SINGLE_INVITATIONS: Loadable({
    loading,
    loader: () => import('../../organisation/screens/customers/screens/customer/screens/invitations/index'),
  }),
  ORGANISATION_CUSTOMERS_SINGLE_INVITATIONS_CREATE: Loadable({
    loading,
    loader: () => import('../../organisation/screens/customers/screens/customer/screens/invitations/screens/create/index'),
  }),
  ORGANISATION_CUSTOMERS_SUBSCRIPTION: Loadable({
    loading,
    loader: () => import('../../organisation/screens/customers/screens/customer/screens/subscription/index'),
  }),
  PREFERENCES_INTERESTS: Loadable({
    loading,
    loader: () => import('../../preferences/screens/interests/index'),
  }),
  PREFERENCES_EMAILS: Loadable({
    loading,
    loader: () => import('../../preferences/screens/emails/index'),
  }),
  PREFERENCES: Loadable({
    loading,
    loader: () => import('../../preferences/index'),
  }),
  ADMIN_SUBSCRIPTIONS: Loadable({
    loading,
    loader: () => import('../../admin/screens/subscriptions/index'),
  }),
  ADMIN_SUBSCRIPTIONS_CREATE: Loadable({
    loading,
    loader: () => import('../../admin/screens/subscriptions/screens/create/index'),
  }),
  ADMIN_SUBSCRIPTIONS_SINGLE: Loadable({
    loading,
    loader: () => import('../../admin/screens/subscriptions/screens/single/index'),
  }),
};

const AccountMain = compose(
  withProps({
    components: sections,
    isLoading: false,
  }),
  connect(R.applySpec({
    page: getPageType,
  })),
)(ComponentMap);

export default AccountMain;
